import axios from "axios";
// @ts-ignore
//import * as SecureStore from "expo-secure-store";
import i18n from "../i18n/config";

import { endPoints, sportEndPoint } from "../constant/Environment";
import { getStoredSessionId } from "./session";
import { PaymentEndpoints } from "../constant/Environment";
import { traceApiError } from "./apiErrorLogger";
import { getUtmTrackingId } from "./utmStorage";

const isPaymentApiUrl = (url) => {
  if (!url) return false;

  // handle relative URLs also
  return url.includes(PaymentEndpoints.apiBaseUrl) ||
         url.includes("/api/casino");
};
export const BASE_URL = endPoints.apiBaseUrl;
export const BASE_URL_BET = sportEndPoint.apiBaseUrl;
const API_TIMEOUT_MS = Number(process.env.REACT_APP_API_TIMEOUT_MS) || 30000;
export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: API_TIMEOUT_MS,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const axiosInstanceBet = axios.create({
  baseURL: BASE_URL_BET,
  timeout: API_TIMEOUT_MS,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Currently selected UI language, as an Accept-Language value.
// Read at call time (not module load) so it follows the language switcher.
// The backend resolves this header and falls back to "en" for anything it
// doesn't support, so region-tagged values like "es-MX" are safe to send.
export const getApiLanguage = () => i18n.language || "en";

// Attribution id from the utm cookie, sent on every request so the backend can
// tie the activity back to the campaign that brought the visitor in. Read at
// call time because the cookie is written after the first api/v1/utm response.
const applyUtmTrackingHeader = (config) => {
  const trackingId = getUtmTrackingId();
  if (trackingId) {
    config.headers["utmTrackingId"] = trackingId;
  }
  return config;
};

// Add language header to every request
axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["Accept-Language"] = getApiLanguage();
    return applyUtmTrackingHeader(config);
  },
  (error) => {
    return Promise.reject(error);
  }
);


axiosInstanceBet.interceptors.request.use(
  (config) => {
    config.headers["Accept-Language"] = getApiLanguage();

    // ❌ REMOVE ALL SESSION HEADERS FOR PAYMENT APIs
    delete config.headers.token;
    delete config.headers.session_id;
    delete config.headers.SessonId;
    delete config.headers.Sessonid;
    delete config.headers.SessionId;

    return applyUtmTrackingHeader(config);
  },
  (error) => Promise.reject(error)
);

const traceFailedRequest = (error) => {
  traceApiError(error);
  return Promise.reject(error);
};

// One response interceptor per shared client gives every API request the same
// 500/404/timeout/unreachable tracing behaviour.
axiosInstance.interceptors.response.use((response) => response, traceFailedRequest);
axiosInstanceBet.interceptors.response.use((response) => response, traceFailedRequest);
